export default "__VITE_ASSET__b7e6fe56__"